import { FeatureToggle } from '@components/common';
import FeatureCheck from '@components/common/FeatureCheck';
import { Main, WithResetTrends } from '@src/pages';
import featureNames from '@utils/featureToggle/constants';
import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router';

const Trends = (props) => {
  return (
    <FeatureToggle
      feature={featureNames.MINI_ODP_ACCESS}
      fallback={<FeatureCheck featureName={'ODP'} />}
    >
      <WithResetTrends>
        <Main {...props} />
      </WithResetTrends>
    </FeatureToggle>
  );
};
const odpTrendsRenderer = () => <Trends />;

const OdpRouter = () => {
  const match = useRouteMatch();
  return (
    <Switch>
      <Route
        exact
        path={`${match.path}/dashboard/:contextId/explore`}
        component={odpTrendsRenderer}
      />
    </Switch>
  );
};

export default OdpRouter;
